module.exports = "<a href=\"http://gbu.ac.in/Admission%20Form.html\" style=\"text-decoration-color: black; text-decoration: none;font-size:15px\" target=\"_blank\"><b>Click Here for Admission Enquiry</b></a>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/home1/dialog-overview-example-dialog.html
// module id = ./src/app/components/home1/dialog-overview-example-dialog.html
// module chunks = main